<template>
  <div class="text-center">
    <svg-loading></svg-loading>
    <h1 class="mb-3 text-xl font-bold" v-if="loading">
      Please wait while we process your appointment. <br />
      Do not reload the page.
    </h1>
    <h1 class="mb-3 text-xl font-bold" v-else>
      <span v-if="status === 'success'"> Success! </span>
      <span v-else>
        {{ error || "Unknown error. Please try again." }}
      </span>
    </h1>
  </div>
</template>

<script>
import { GET_APPOINTMENT_STATUS } from "@/graphql";
import { GraphQLClient } from "graphql-request";
import SvgLoading from "@/components/Svg/SvgLoading";

export default {
  components: { SvgLoading },
  mounted() {
    this.intervalID = window.setInterval(this.request, 2000);
  },
  props: ["statusUrl"],
  data() {
    return {
      status: null,
      error: null,
      loading: true,
    };
  },
  computed: {
    variables() {
      return {
        token: this.statusUrl || "",
      };
    },
    options() {
      return {
        headers: {
          authorization: `Bearer ${this.$store.state.config.token}`,
        },
      };
    },
  },
  methods: {
    request() {
      const client = new GraphQLClient(
        this.$store.state.config.endpoint,
        this.options
      );
      client
        .request(GET_APPOINTMENT_STATUS, this.variables)
        .then((data) => {
          console.log(data?.getAppointmentStatus);
          if (data?.getAppointmentStatus?.status === "success") {
            return this.$emit("success");
          }
          if (data?.getAppointmentStatus?.status === "expired") {
            return this.$emit(
              "error",
              "Appointment request has expired. Please try again."
            );
          }
          if (data?.getAppointmentStatus?.status === "failed") {
            return this.$emit(
              "error",
              "Appointment request has failed. Please try again."
            );
          }
          if (data?.getAppointmentStatus?.status === "taken") {
            return this.$emit("error", data?.getAppointmentStatus?.error);
          }
          if (data?.getAppointmentStatus?.status === "error") {
            return this.$emit(
              "error",
              data?.getAppointmentStatus?.error ||
                "Unknown error occurred. Please try again."
            );
          }
        })
        .catch(({ error }) => (this.error = error?.message));
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalID);
  },
};
</script>
